import Box from '@mui/material/Box';

const NotFound = () => {
  return (
    <Box px={3} py={3} sx={{ padding: '80px 16px 16px 241px' }}>
      <h1>Page - Not Found!</h1>
    </Box>
  );
};

export default NotFound;
